import { TOTAL_DRIVING_TIME, TOTAL_DRIVING_MIN, TOTAL_RECORDING_TIME, TOTAL_RECORDING_MIN, CLEAR_REDUX } from "../actionTypes";

const initialState = {
    totalDriveMin: 0,
    toalDriveTime: "00:00:00",
    totalRecordingTime: "00:00:00",
    totalRecordingMin: 0,
}

export const totalDriveTimeReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOTAL_DRIVING_TIME:
            return {
                ...state,
                toalDriveTime: action.payload
            };
        case TOTAL_DRIVING_MIN:
            return {
                ...state,
                totalDriveMin: action.payload
            };
        case TOTAL_RECORDING_TIME:
            return {
                ...state,
                totalRecordingTime: action.payload
            };
        case TOTAL_RECORDING_MIN:
            return {
                ...state,
                totalRecordingMin: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}